import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { EmployerFormService } from './employer.form.service';
import { Formvalidator } from './employer.form.formvalidator';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { AppService } from '../../app.service';
import { FormGroup, FormControl, FormArray, Validators, ValidatorFn, AbstractControl  } from '@angular/forms';
import { ActivatedRoute } from '@angular/router'; 
import { DepartmentTreeComponent } from '../../shared/views/DepartmentTreeComponent/department.tree.component'; 
import { EmployerType } from '../../shared/enum/EmployerType'
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Countries } from '../../shared/countries/countries';
import translateJson from "../../../translate.json";
import customerJson from "../../../assets/config/customer.json";

import { ValidationModalComponent } from '../../shared/views/ValidationModalComponent/validation.modal.component';
import { HierarchyModalComponent } from '../../shared/views/HierarchyModalComponent/hierarchy.modal.component';

import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';
import { ConfirmModalService } from 'app/shared/views/ConfirmModalComponent/confirm.modal.service';
import { AuthenticationService } from '../../auth';

enum otherTypeEnum {"Employer"};
enum viewType { ADDRESS, CONTACTPERSON, GOVERNMENT, OFFICE };
enum StructureElementType { MINISTRY, ENTITY, SECTION };

@Component({
    selector: 'employer-comp',
    providers: [EmployerFormService, Formvalidator, ConfirmService, AppService, ConfirmModalService, Countries, AuthenticationService],
    templateUrl: './employer.form.component.html',
    styleUrls: ['../employer.component.css']
})

export class EmployerFormComponent {
    @ViewChild('validationModal') validationModal: ValidationModalComponent;
    @ViewChild('treeComponent') treeComponent: DepartmentTreeComponent;
    @ViewChild('hierarchyModal') hierarchyModal: HierarchyModalComponent;

    // Get translation/text from customerJson
    private i18 = translateJson.i18;
    private customerOrgId: String = customerJson.customer.organisationId;
    private customerName: String = customerJson.customer.name;
    showLocalOffices: boolean = customerJson.settings.showLocalOffices;
  
    private employer: any;
    private previousType: String;
    
    employerForm: FormGroup;
    employerAddressForm: FormGroup;
    securityManagerForm: FormGroup;
    admContactForm: FormGroup;
    govMinistryForm: FormGroup;
    govEntityForm: FormGroup;
    govSectionForm: FormGroup;

    localOfficeForm: FormGroup;

    otherType: String = otherTypeEnum[0];
    selectedEmployer: any;
    
    isCustomer: boolean = false;

    /* View Employer */
    showEmployerInformation: Boolean = true;
    showOtherInformation: Boolean = true;
    showDateDetailsInformation: Boolean = true;
    showRegisterDetailsInformation: Boolean = true;
    showContactDetailsInformation: Boolean = true;
    showNoteEditor: Boolean = false;
    showNotesDetails: Boolean = true;
    showLoader: Boolean = false;
    selectedView: any;
    selectedDepartmentOption: number;
    departmentArray: any = [];
    employerTypeArray: any = [];

    id: String;
    type: String;
    ready: Boolean = false;
    doesOrgNrAlreadyExist: Boolean = false;

    departmentId: String;
    
    ministryArray: any = [];
    entityArray: any = [];
    sectionArray: any = [];
    selectedMinistryId: String;
    selectedEntityId: String;

    alertAddedLocalOffice: boolean = false;
    alertDeletedLocalOffice: boolean = false;
    lastLocalOfficeDeleted: boolean = false;
    localOfficeArray: any = [];
    numOfNotes:number = 0;
    parentEmployersList: any = [];
    parentEmployer: any;
    parentEmployerSelected: boolean = false;
    /* Enum */
    StructureElementType = StructureElementType;

    /**
     * Constructor
     * @param service           Service for this view
     * @param formValidator     Validation class
     * @param confirmService    Service for confirm modal
     * @param activatedRoute    Route for the URL
     * @param location          To be able to go back to previous view
     * @param appService        General service for whole app
     */
    constructor(
      private service: EmployerFormService,
      private formValidator: Formvalidator,        
      private confirmService: ConfirmService,
      private activatedRoute : ActivatedRoute,
      private location: Location,
      private appService: AppService,
      private ConfirmModalService: ConfirmModalService,
      private countries: Countries,
      private authService: AuthenticationService) {
        this.authService.isAuthenticated();
        this.id = this.activatedRoute.snapshot.paramMap.get('id');
        this.type = this.activatedRoute.snapshot.paramMap.get('type');
        if(this.id != null && this.type === 'edit') {
          this.editEmployer(this.id);
        } else if (this.id === null && this.type === 'new') {
          this.addEmployer();
        } else if (this.id === null && this.type === 'newsub') {
          this.getParentEmployers();
        }
    }

    /**
     * Make preparations to add a new Employer
     */
    addEmployer() {
        this.setDefault();
        this.setInputWindow('ADDRESS');
        this.ready = true;
    }

    /**
     * Set the URL-route to the specified route
     * @param route Route to change to
     */
    setRoute(route) {
        this.appService.setRoute(route);
    }

    /**
     * Go back to the previous view from where we came
     */
    back() {
        this.confirmService.confirm(this.i18.organisation.form.confirmNoSave)
            .then(result => {
                if(result) {
                    this.location.back();
                }
            });
    }

    setDefault() {
        this.employerForm = new FormGroup({
          id: new FormControl(),
          name: new FormControl(),
          organisationId: new FormControl(),
          contactMail: new FormControl(),
          contactPhone: new FormControl(),
          suaStatus: new FormControl(),
          employerType: new FormControl(),
          countryCode: new FormControl(),
          parentOrganisationId: new FormControl()
        });

        this.employerTypeArray.push({value: "Företag", name: this.i18.organisation.form.organisationType4Label});
        this.employerTypeArray.push({value: "Kommun", name: this.i18.organisation.form.organisationType3Label});
        this.employerTypeArray.push({value: "Landsting", name: this.i18.organisation.form.organisationType2Label});
        this.employerTypeArray.push({value: "Myndighet", name: this.i18.organisation.form.organisationType1Label});


        /**
        * Old implementation of departments
        * /
        /* this.employerDepartments = new FormGroup({
            departmentInput: new FormControl(),
            selectedDepartment: new FormControl(),
            'departments': new FormArray([])
        });*/

        this.employerAddressForm = new FormGroup({
            id: new FormControl(),
            address_1: new FormControl(),
            address_2: new FormControl(),
            postCode: new FormControl(),
            city: new FormControl()
        });

        this.securityManagerForm = new FormGroup({
            id: new FormControl(),
            contactName: new FormControl(),
            contactPhone: new FormControl(),
            contactMail: new FormControl(),
            contactType: new FormControl()
        });
        
        this.securityManagerForm.patchValue({     
            contactType: "SM"
        });

        this.admContactForm = new FormGroup({
            id: new FormControl(),
            contactName: new FormControl(),
            contactPhone: new FormControl(),
            contactMail: new FormControl(),
            contactType: new FormControl()
        });
        
        this.admContactForm.patchValue({     
            contactType: "AC"
        });
        
        this.govMinistryForm = new FormGroup({
            id: new FormControl(),
            newMinistry: new FormControl("", [Validators.required, Validators.minLength(2)]),
            selectedMinistry: new FormControl(null)
        });
        this.govEntityForm = new FormGroup({
            id: new FormControl(),
            newEntity: new FormControl({value: "", disabled: true}, [Validators.required, Validators.minLength(1)]),
            selectedEntity: new FormControl({value: null, disabled: true})
        });
        this.govSectionForm = new FormGroup({
            id: new FormControl(),
            newSection: new FormControl({value: "", disabled: true}, [Validators.required, Validators.minLength(1)]),
            selectedSection: new FormControl({value: null, disabled: true})
        });

        this.localOfficeForm = new FormGroup({
          address: new FormControl(null, [this.fieldsNotNull(), this.fieldSpecified()]),
          postcode: new FormControl({value:"", disabled: false}),
          county: new FormControl({value:"", disabled: false}),
          selectedLocalOffice: new FormControl()
        });

        this.employerForm.patchValue({
          countryCode: 'SE'
        });
    }
    
    /**
     * Activates the government tab and populates the options array.
     */
    enableGovTab() {
      this.service.getAllDepartments().subscribe(
        data => this.patchDepartments(data),
        error => this.showError(error.error)
      )
    }
    
    /**
     * Activates the LocalOffice tab and populates the drop down menu.
     */
    enableOfficeTab() {
      this.localOfficeArray = this.employer.localOffices;
    }

    patchOffice(data){
      //this.dataSource.data = data;
    }
    /**
     * Enables/disables, resets the formcontrols and clears arrays depending on what change
     * event that occured
     * @param from from what change event the call came from.
     * @param value True/false whether to enable or not.
     */
    enableInputs(from, value: boolean){      
      if(from === 'ministry' && !value){
        this.entityArray = [];
        this.sectionArray = [];
        this.govEntityForm.get('newEntity').disable();
        this.govEntityForm.get('selectedEntity').disable();
        this.govEntityForm.get('selectedEntity').reset();
        this.govEntityForm.get('newEntity').reset();
        
        this.govSectionForm.get('newSection').disable();
        this.govSectionForm.get('selectedSection').disable();
        this.govSectionForm.get('selectedSection').reset();
        this.govSectionForm.get('newSection').reset();
      } else if (from === 'ministry' && value){
        this.govEntityForm.get('newEntity').enable();
        this.govEntityForm.get('selectedEntity').enable();
        this.govEntityForm.get('selectedEntity').setValue(null);
        this.enableInputs('entity', false);
      }
      
      if(from === 'entity' && !value){
        this.sectionArray = [];
        this.govSectionForm.get('newSection').disable();
        this.govSectionForm.get('selectedSection').disable();
        this.govSectionForm.get('selectedSection').reset();
        this.govSectionForm.get('newSection').reset();
      } else if (from === 'entity' && value){
        this.govSectionForm.get('newSection').enable();
        this.govSectionForm.get('selectedSection').enable();
        this.govSectionForm.get('selectedSection').setValue(null);
      }
    }
    
    /**
     * Helper to clear all data when the organisation type is changed
     * @param value type of organisation
     */
    resetGov(){
      this.sectionArray = [];
      this.entityArray = [];
      this.ministryArray = [];
      this.enableInputs('ministry', false);
      this.govMinistryForm.get('newMinistry').reset();
      this.govMinistryForm.get('selectedMinistry').reset();
    }
    
    /**
     * Refreshes the entity array with data
     * @param ministryId id of the selected ministry
     */
    patchEntityArr(ministryId){
      if(ministryId === null){
        this.selectedMinistryId = null;
      } else {
        this.selectedMinistryId = ministryId;
        this.entityArray = this.ministryArray.find(ministry => ministry.id === ministryId).govEntity
      }
    }
    
    /**
     * Refreshes the Ministry array with new data
     * @param data updated data from backend
     */
    patchMinistryArr(){
      this.service.getAllDepartments().subscribe(
        data => {
          this.ministryArray = data
          this.patchEntityArr(this.selectedMinistryId)
          this.patchSectionArr(this.selectedEntityId)
        },
        error => this.showError(error)
      )
    }
    
    /**
     * Refreshes the section array with data
     * @param entityId id of the selected entity
     */
    patchSectionArr(entityId){
      if(entityId === null){
        this.selectedEntityId = null;
      } else {
        this.selectedEntityId = entityId;
        this.sectionArray = this.entityArray.find(entity => entity.id === entityId).govSection
      }
    }
    
    /**
     * Adds a new ministry
     * @param newMinistryName name of the ministry to be added
     */
    addMinistry(newMinistryName){
      let alreadyExists: boolean = false;

      if(this.ministryArray.length > 0){
        alreadyExists = this.ministryArray.find(ministry => ministry.ministryName.toUpperCase() === newMinistryName.toUpperCase()) ? true : false;
      }
      
      if(!alreadyExists){
        let newMinistry = {
          ministryName: newMinistryName
        }
        this.service.addGovMinistry(newMinistry)
          .subscribe(
            data => {
              if(this.ministryArray === undefined){
                this.ministryArray = []; 
              }
              this.ministryArray.push(data);
              this.govMinistryForm.get('newMinistry').reset();
            },
            error => this.showError(error)
        );      
      } else {
        let errStr = `${this.i18.goverment.form.govermentPart1Label} ${this.i18.organisation.form.withName} "${newMinistryName}" ${this.i18.organisation.form.alreadyExists}`
        this.confirmService.error(errStr);
      }
    }
    
    /**
     * Adds a new entity
     * @param newEntityName name of the entity to be added
     */
    addEntity(newEntityName){
      let alreadyExists: boolean = false;

      if(this.entityArray.length > 0){
        alreadyExists = this.entityArray.find(entity => entity.entityName.toUpperCase() === newEntityName.toUpperCase()) ? true : false;
      }
      
      if(!alreadyExists){
        let newEntity = {
          entityName: newEntityName
        }
        this.service.addGovEntity(newEntity, this.govMinistryForm.value.selectedMinistry).subscribe(
          data => {
            this.patchMinistryArr()
            this.govEntityForm.controls.selectedEntity.setValue(data.id)
            this.selectedEntityId = data.id
            this.govEntityForm.controls.newEntity.reset();
            this.enableInputs('entity', true)
          },
          error => this.showError(error)
        )     
      } else {
        let errStr = `${this.i18.goverment.form.govermentPart2Label} ${this.i18.organisation.form.withName} "${newEntityName}" ${this.i18.organisation.form.alreadyExists}`
        this.confirmService.error(errStr);
      }
    }
    
    /**
     * Adds a new section
     * @param newSectionName name of the section to be added
     */
    addSection(newSectionName){
      let alreadyExists:boolean = false;

      if(this.sectionArray.length > 0){
        alreadyExists = this.sectionArray.find(section => section.sectionName.toUpperCase() === newSectionName.toUpperCase()) ? true : false;
      }
      
      if(!alreadyExists){
        let newSection = {
          sectionName: newSectionName
        }
        
        this.service.addGovSection(newSection, this.govEntityForm.value.selectedEntity).subscribe(
          data => {
            this.patchMinistryArr()
            this.govSectionForm.controls.selectedSection.setValue(data.id)
            this.govSectionForm.controls.newSection.reset();
          },
          error => this.showError(error)
        )     
      } else {
        let errStr = `${this.i18.goverment.form.govermentPart3Label} ${this.i18.organisation.form.withName} "${newSectionName}" ${this.i18.organisation.form.alreadyExists}`
        this.confirmService.error(errStr);
      }
    }
    
    /**
     * Updates a the name of a ministry
     * @param newMinistryName new name of the ministry to be updated
     * @param ministryId id of the ministry to be updated
     */
    updateMinistry(newMinistryName, ministryId){
      let alreadyExists:boolean = false;
      let changedCase: boolean = false;

      if(this.ministryArray.length > 0){
        this.ministryArray.forEach(ministry => {
          if(ministry.ministryName.toUpperCase() === newMinistryName.toUpperCase()){
            alreadyExists = true;
            changedCase = ministry.ministryName !== newMinistryName;
          }
        });
      }
      
      if(!alreadyExists){
        // Check if new ministry name exists as soft deleted.
        this.service.getGovMinistryByName(newMinistryName).subscribe(
          data => {
            const existsAsArchivedMsg = `${this.i18.goverment.form.govermentPart1Label} ${this.i18.organisation.form.withName} "${newMinistryName}" ${this.i18.organisation.form.cantChangeNameOnArchived} "${newMinistryName}"?`
            this.confirmService.confirm(existsAsArchivedMsg)
              .then(wantsToRestore => {
                if (wantsToRestore) this.addMinistry(newMinistryName);
              })
          },
          notFound => this.confirmUpdateMinistry(newMinistryName, ministryId)
        )    
      } 
      else if (alreadyExists && changedCase) {
        this.confirmUpdateMinistry(newMinistryName, ministryId);
      }
      else {
          let errStr = `${this.i18.goverment.form.govermentPart1Label} ${this.i18.organisation.form.withName} "${newMinistryName}" ${this.i18.organisation.form.alreadyExists}`
          this.confirmService.error(errStr);
      }
    }

    /**
     * Asks user to confirm change then executes the request on confirmed.
     * @param newMinistryName name of the ministry to be updated
     * @param ministryId id of the ministry to be updated
     */
    confirmUpdateMinistry(newMinistryName, ministryId) {
      const ministry = this.ministryArray.find(m => m.id === ministryId);
      const confirmMsg = `Vill du ändra namn på ${this.i18.goverment.form.govermentPart1Label} ${this.i18.organisation.form.withName} "${ministry.ministryName}" ${this.i18.organisation.form.changeTo} ${newMinistryName}?`;
      this.confirmService.confirm(confirmMsg)
        .then(wantsToChange => {
          if (wantsToChange) {
            const oldName = ministry.ministryName;
            const type = 'ministry';
            ministry.ministryName = newMinistryName;
            
            this.service.updateGovName(ministry, ministryId, oldName, type, newMinistryName, null).subscribe(
              data => this.govMinistryForm.controls.newMinistry.reset(),
              error => this.showError(error)
            )
          }
        })
    }
    
    /**
     * Updates a the name of a entity
     * @param newEntityName new name of the entity to be updated
     * @param entityId id of the entity to be updated
     */
    updateEntity(newEntityName, entityId){
      let alreadyExists:boolean = false;
      let changedCase: boolean = false;
      if(this.entityArray.length > 0){
        this.entityArray.forEach(entity => {
          if(entity.entityName.toUpperCase() === newEntityName.toUpperCase()){
            alreadyExists = true;
            changedCase = entity.entityName !== newEntityName;
          }
        });
      }
      
      if(!alreadyExists){
        // Check if new entity name exists as soft deleted.
        this.service.getGovMinistryByIdAndEntityName(this.govMinistryForm.value.selectedMinistry, newEntityName).subscribe(
          data => {
            const existsAsArchivedMsg = `${this.i18.goverment.form.govermentPart2Label} ${this.i18.organisation.form.withName} "${newEntityName}" ${this.i18.organisation.form.cantChangeNameOnArchived} "${newEntityName}"?`
            this.confirmService.confirm(existsAsArchivedMsg)
              .then(wantsToRestore => {
                if (wantsToRestore) this.addEntity(newEntityName);
              })
          },
          notFound => this.confirmUpdateEntity(newEntityName, entityId)
        )    
      } 
      else if (alreadyExists && changedCase) {
        this.confirmUpdateEntity(newEntityName, entityId);
      }
      else {
        let errStr = `${this.i18.goverment.form.govermentPart2Label} ${this.i18.organisation.form.withName} "${newEntityName}" ${this.i18.organisation.form.alreadyExists}`
        this.confirmService.error(errStr);
      }
    }

    /**
     * Asks user to confirm change then executes the request on confirmed.
     * @param newEntityName new name of the entity to be updated
     * @param entityId id of the entity to be updated
     */
    confirmUpdateEntity(newEntityName, entityId) {
      const ministry = this.ministryArray.find(m => m.id === this.govMinistryForm.value.selectedMinistry)
      const entity = this.entityArray.find(e => e.id === entityId);
      const confirmMsg = `Vill du ändra namn på ${this.i18.goverment.form.govermentPart2Label} ${this.i18.organisation.form.withName} "${entity.entityName}" ${this.i18.organisation.form.changeTo} ${newEntityName}?`;
      this.confirmService.confirm(confirmMsg)
        .then(wantsToChange => {
          if (wantsToChange) {
            const oldName = entity.entityName;
            const type = 'entity';
            entity.entityName = newEntityName;
            
            this.service.updateGovName(ministry, ministry.id, oldName, type, newEntityName, null).subscribe(
              data => this.govEntityForm.controls.newEntity.reset(),
              error => this.showError(error)
            )
          }
        })
    }
    
    /**
     * Updates a the name of a section
     * @param newSectionName new name of the section to be updated
     * @param sectionId id of the section to be updated
     */
    updateSection(newSectionName, sectionId){
      let alreadyExists:boolean = false;
      let changedCase: boolean = false;
      if(this.sectionArray.length > 0){
        this.sectionArray.forEach(section => {
          if(section.sectionName.toUpperCase() === newSectionName.toUpperCase()){
            alreadyExists = true;
            changedCase = section.sectionName !== newSectionName;
          }
        });
      }
      
      const ministry = this.ministryArray.find(m => m.id === this.govMinistryForm.value.selectedMinistry);
      const entity = this.entityArray.find(e => e.id === this.govEntityForm.value.selectedEntity);
      if(!alreadyExists){
        // Check if new section name exists as soft deleted.
        this.service.getGovMinistryByIdAndEntityIdAndSectionName(ministry.id, entity.id, newSectionName).subscribe(
          data => {
            const existsAsArchivedMsg = `${this.i18.goverment.form.govermentPart3Label} ${this.i18.organisation.form.withName} "${newSectionName}" ${this.i18.organisation.form.cantChangeNameOnArchived} "${newSectionName}"?`
            this.confirmService.confirm(existsAsArchivedMsg)
              .then(wantsToRestore => {
                if (wantsToRestore) this.addSection(newSectionName);
              })
          },
          notFound => this.confirmUpdateSection(newSectionName, sectionId, ministry, entity)
        )   
      } 
      else if (alreadyExists && changedCase) {
        this.confirmUpdateSection(newSectionName, sectionId, ministry, entity);
      }
      else {
        let errStr = `${this.i18.goverment.form.govermentPart3Label} ${this.i18.organisation.form.withName} "${newSectionName}" ${this.i18.organisation.form.alreadyExists}`
        this.confirmService.error(errStr);
      }
    }

    /**
     * Asks user to confirm change then executes the request on confirmed.
     * @param newSectionName new name of the section to be updated.
     * @param sectionId id of the section to be updated.
     * @param ministry The ministry to which the section belongs to.
     * @param entity The entity to which the section belong to. 
     */
    confirmUpdateSection(newSectionName, sectionId, ministry, entity) {
      const section = this.sectionArray.find(s => s.id === sectionId)
      const confirmMsg = `${this.i18.organisation.form.wantToChangeNameOn} ${this.i18.goverment.form.govermentPart3Label} ${this.i18.organisation.form.withName} "${section.sectionName}" ${this.i18.organisation.form.changeTo} ${newSectionName}?`;
      this.confirmService.confirm(confirmMsg)
        .then(wantsToChange => {
          if (wantsToChange) {
            const oldName = section.sectionName;
            const type = 'section';
            section.sectionName = newSectionName;
            
            this.service.updateGovName(ministry, ministry.id, oldName, type, newSectionName, entity.entityName).subscribe(
              data => this.govSectionForm.controls.newSection.reset(),
              error => this.showError(error)
            )
          }
        })
    }
    
    /**
     * populates the initial ministry array
     * @param data An array of ministries
     */
    patchDepartments(data) {      
      if(this.ministryArray.length > 0){
        this.ministryArray = [];
      }
      if(data.length > 0) {
        this.ministryArray = data        
      }
    }
    
    /*
    * Helper to validate data before populating the array with it
    */
    validateInput(inputName, formArray) {
        let validInput = true;
        for(let i=0; i < formArray.length; i++) {
            if (inputName.toUpperCase() == formArray.value[i].ministryName.toUpperCase()) {
                validInput = false;
            }
        }
        return validInput;
    }
        
    /**
     * Create a new Employer
     * @param employerForm Inputform with information about the Employer to be created
     * @param employerAddressForm Inputform with address information
     * @param securityManagerForm Inputform with informaton about the security manager
     * @param admContactForm InputForm with information about the administration contact
     */
    createEmployer(employerForm, employerAddressForm, securityManagerForm, admContactForm, localOfficeForm) {      
        let employer = employerForm;
        this.setInputWindow("ADDRESS");
        employer.organisationId = employer.organisationId;
        employer.addresses = [];
        employer.addresses.push(employerAddressForm);
        employer.contacts = [];
        employer.contacts.push(securityManagerForm);
        employer.contacts.push(admContactForm);     
        employer.localOffices = localOfficeForm.localOffices;

        //patch parents disabled values
        if(this.type === 'newsub') {
          employer.organisationId = this.parentEmployer.organisationId;
          employer.suaStatus = employer.suaStatus,
          employer.employerType = this.parentEmployer.employerType,
          employer.countryCode = this.parentEmployer.countryCode
        }
        
        this.service.createEmployer(employer).subscribe(
            data => this.setRoute('employer/view/' + data.id),
            error => this.showError(error)
        );    
    }

     /**
     * Update a employer
     * @param employerForm Inputform with information about the employer to be created
     * @param employerAddressForm Inputform with address information
     * @param securityManagerForm Inputform with informaton about the security manager
     * @param admContactForm InputForm with information about the administration contact
     */
    updateEmployer(employerForm, employerAddressForm, securityManagerForm, admContactForm, localOfficeForm) {
        let employer = employerForm;        
        employer.organisationId = employer.organisationId;       
        employer.addresses = [];
        employer.addresses.push(employerAddressForm);
        employer.contacts = [];

        if(this.securityManagerForm.value.contactName != null) {
            employer.contacts.push(securityManagerForm);
        }
        if(this.admContactForm.value.contactName != null) {
            employer.contacts.push(admContactForm);
        }        

        employer.localOffices = this.localOfficeArray;
        
        if(this.parentEmployerSelected) {
          employer.organisationId = this.parentEmployer.organisationId;
          employer.suaStatus = employer.suaStatus,
          employer.employerType = this.parentEmployer.employerType,
          employer.countryCode = this.parentEmployer.countryCode
        }
        
        this.service.updateEmployer(employer).subscribe(
            data => this.setRoute('employer/view/' + data.id),
            error => this.showError(error)
        );  
    }
    
    /* Error modal on employer creation */
    showError(error) {
        this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
    }

    /**
     * Set tab view for address or contact person
     * @param type type of address
     */
    setInputWindow(type) {
        this.selectedView=type;
        if(this.previousType==='DEPARTMENT') {
            this.departmentId = this.treeComponent.getDepartmentId();
        }
        this.previousType=type;
    }

    /**
     * Sets the selected employer to be the data in the data parameter
     * @param data json data of the employer to be set
     */
    displayEmployer(data) {   
        this.employer= data
        this.selectedEmployer = data;
        if(this.employer.parentOrganisationId != null){
          this.service.getEmployerById(this.employer.parentOrganisationId)
            .subscribe(
              data => this.setParentForEdit(data),
              error => this.showError(error)
            );
        }
        this.setEmployerInfo();
        this.setInputWindow('ADDRESS');
        // set the number of notes on first load. this will then be updated when a user adds/removes notes
        this.numOfNotes = this.employer.notes.length;
        this.ready = true;
    }

    /**
     * Retrieves information about the employer to be edited and prepares forms
     * @param id the employer unique id
     */
    editEmployer(id) {
        this.service.getEmployerById(id)      
          .subscribe(
            data => this.displayEmployer(data),
            error =>  this.showError(error)      
          );  
    }

    /**
     * Initiate forms with information
     */
    setEmployerInfo() {
        this.setDefault()
        this.employerForm.patchValue({
          id: this.employer.id,
          name: this.employer.name,
          organisationId: this.employer.organisationId,
          contactMail: this.employer.contactMail,
          contactPhone: this.employer.contactPhone,
          suaStatus: this.employer.suaStatus,
	        employerType: this.employer.employerType,
          countryCode: this.employer.countryCode,
          parentOrganisationId: this.employer.parentOrganisationId
        });
        for(let i = 0; i < this.employer.contacts.length; i++) {      
            if (this.employer.contacts[i].contactType == "SM") {
              this.securityManagerForm.patchValue({
                id: this.employer.contacts[i].id,
                contactName: this.employer.contacts[i].contactName,
                contactPhone: this.employer.contacts[i].contactPhone,
                contactMail: this.employer.contacts[i].contactMail
              })
            } else if (this.employer.contacts[i].contactType == "AC") {
              this.admContactForm.patchValue({
                id: this.employer.contacts[i].id,
                contactName: this.employer.contacts[i].contactName,
                contactPhone: this.employer.contacts[i].contactPhone,
                contactMail: this.employer.contacts[i].contactMail
              });
            }
        }
        for(let i = 0; i < this.employer.addresses.length; i++) {
            this.employerAddressForm.patchValue({
                id: this.employer.addresses[i].id,
                address_1: this.employer.addresses[i].address_1,
                address_2: this.employer.addresses[i].address_2,
                postCode: this.employer.addresses[i].postCode,
                city: this.employer.addresses[i].city
            })
        }

        if (this.employer.organisationId === this.customerOrgId) {
          this.isCustomer = true;
          this.disableCustomerFields();
          this.enableGovTab();
          this.enableOfficeTab();
        }       
    }
    
    /**
     * Format org nr
     * @param orgNr
     */
    fixOrgnr(orgNr, countryCode) {
      if (countryCode === 'SE' && orgNr.length >= 10) {
        orgNr = orgNr.replace(/-/g, "").trim(); // Remove if exist in case its in a wrong position
        let firstPart = orgNr.substring(0,6);
        let lastPart = orgNr.substring(6,10)
        orgNr = firstPart + "-" + lastPart; // Format in NNNNNN-NNNN
      }

      // Validate if employer already exists
      this.service.doesEmployerOrgNrExists(orgNr, countryCode)
      .subscribe(
        data => this.doesOrgNrExist(data),
        () => this.showLoader = false
      );

      this.employerForm.patchValue({
          organisationId: orgNr
      });
    }

    /**
     * Disable the input fields that should not be editable for the customer organisation.
     */
    disableCustomerFields(): void {
      this.employerForm.controls.organisationId.disable();
    }
    
    /**
     * Add form action when validating existing orgNR
     * @param doesExist
     */
    doesOrgNrExist(doesExist) {
      if(doesExist) {
        this.formValidator.formValidation.employerOrgIdError = true;
        this.doesOrgNrAlreadyExist = true;
      } else {
        this.formValidator.formValidation.employerOrgIdError = false;
        this.doesOrgNrAlreadyExist = false;
      }
    }

    /**
     * Deletes the structure element based on ID and type.
     * @param id ID of the structure element.
     * @param type A StructureElementType.
     */
    deleteOrgStructureElement(id: string, type: StructureElementType) {
      if (type === StructureElementType.MINISTRY) {
        this.deleteGovMinistry(id);
      }
      else if (type === StructureElementType.ENTITY) {        
        this.deleteGovEntity(id);
      }
      else if (type === StructureElementType.SECTION) {
        this.deleteGovSection(id);
      }
      else {
        this.showError(this.i18.organisation.form.couldNotRemove);
      }
    }

    /**
     * Deletes the GovMinistry and all its associated GovEntities and
     * GovSections, if the given ID exists.
     * @param id The ID of the GovMinistry.
     */
    async deleteGovMinistry(id: string) {
      const ministry = this.ministryArray.find(m => m.id === id)

      if (ministry) {
        const wantsToDelete = await this.confirmService.confirm(
          `${this.i18.organisation.form.confirmRemove} ${this.i18.goverment.form.govermentPart1Label.toLowerCase()} ${this.i18.organisation.form.withName} "${ministry.ministryName}"?
          ${this.i18.organisation.form.noteThatAll} ${this.i18.goverment.form.govermentPart2Label}-${this.i18.organisation.form.relationAnd} ${this.i18.goverment.form.govermentPart3Label}-${this.i18.organisation.form.relationTo} "${ministry.ministryName}" ${this.i18.organisation.form.willBeRemoved}
          ${this.i18.organisation.form.removeMinistry}`
        )

        if (wantsToDelete) {
          this.service.deleteGovMinistry(ministry.id).subscribe(
            deletedMinistry => {
              this.ministryArray = this.ministryArray.filter(ministry => ministry.id !== deletedMinistry.id)
              this.govMinistryForm.reset()
              this.enableInputs('ministry', false)
            },
            error => this.showError(error)
          )
        }
      }
      else {
        this.confirmService.error(this.i18.organisation.form.somethingWrong)
      }
    }

    /**
     * Deletes the GovEntity and all its associated GovSections,
     * if the given ID exists.
     * @param id The ID of the GovEntity.
     */
    async deleteGovEntity(id: string) {
      const entity = this.entityArray.find(e => e.id === id)

      if (entity) {
        const wantsToDelete = await this.confirmService.confirm(
          `${this.i18.organisation.form.confirmRemove} ${this.i18.goverment.form.govermentPart2Label.toLowerCase()} ${this.i18.organisation.form.withName} "${entity.entityName}"?
          ${this.i18.organisation.form.noteThatAll} ${this.i18.goverment.form.govermentPart3Label}-${this.i18.organisation.form.relationTo} "${entity.entityName}" ${this.i18.organisation.form.willBeRemoved}
          ${this.i18.organisation.form.removeMinistry}`
        )

        if (wantsToDelete) {
          this.service.deleteGovEntity(entity.id).subscribe(
            deletedEntity => {
              this.selectedEntityId = null;
              this.enableInputs('entity', false)
              this.patchMinistryArr();
            },
            error => this.showError(error)
          )
        }
      }
      else {
        this.confirmService.error(this.i18.organisation.form.somethingWrong)
      }
    }

    /**
     * Deletes the GovSection if the given ID exists.
     * @param id The ID of the GovSection.
     */
    async deleteGovSection(id: string) {
      const section = this.sectionArray.find(s => s.id === id);

      if (section) {
        const wantsToDelete = await this.confirmService.confirm(
          `${this.i18.organisation.form.confirmRemove} ${this.i18.goverment.form.govermentPart3Label.toLowerCase()} ${this.i18.organisation.form.withName} "${section.sectionName}"?
          ${this.i18.organisation.form.removeMinistry}`
        );
        
        if (wantsToDelete) {
          this.service.deleteGovSection(section.id).subscribe(
            deletedSection => {
              this.patchMinistryArr();
            },
            error => this.showError(error)
          )
        }
      }
      else {
        this.confirmService.error(this.i18.organisation.form.somethingWrong);
      }
    }

    /**
     * opens the hierarcy modal to add or edit a hierarcy
     * @param type new or edit
     */
    openHierarcyModal(type){

      // Finalize entity and prepare to show modal
      //this.archiveModal.setEntityData(entityObject);

      // Display modal

      this.hierarchyModal.setModalData([type])
      this.hierarchyModal.pop()
    }

    /**
   * Remove a localOffices from the list
   * @param localOfficeIndex 
   */
  deleteLocalOffice(index) {
    this.alertAddedLocalOffice = false;
    let localOfficeToRemove = this.localOfficeArray[index].address + " - " + this.localOfficeArray[index].postcode + " - " + this.localOfficeArray[index].county;
    let title = this.i18.organisation.form.deleteLocalOfficeTitle;
    let msg = [this.i18.organisation.form.deleteLocalOfficeMsg1, this.i18.organisation.form.deleteLocalOfficeMsg2 + " " + localOfficeToRemove];
    this.ConfirmModalService.pop(msg, title, true, this.i18.organisation.form.deleteButton, true, this.i18.organisation.form.cancelButton, "warning")
    .then(deleteConfirmed => {
      if (deleteConfirmed) {
        this.localOfficeArray.splice(index, 1);
        this.localOfficeForm.controls.selectedLocalOffice.setValue(null)
        this.alertDeletedLocalOffice = true;

        if (this.localOfficeArray.length === 0) {
          this.alertAddedLocalOffice = false;
          this.lastLocalOfficeDeleted = true;
        }
      }
    })
  }

  /**
     * Adds a local office to the list after checkin the validators
     * 
     * @param localOfficeForm The local office form group
     */
  addLocalOfficeToList(localOfficeForm) {
    this.alertDeletedLocalOffice = false;
    const values = localOfficeForm.value
    if(values.address != null){
      const localOfficeToAdd = {
        id: null,
        address: values.address,
        postcode: values.postcode || this.i18.organisation.form.undefined,
        county: values.county || this.i18.organisation.form.undefined
      }
      if(this.localOfficeExists(localOfficeToAdd)){
        let title = this.i18.organisation.form.addLocalOfficeTitle;
        let msg = [this.i18.organisation.form.addLocalOfficeMsg1, `${localOfficeToAdd.address} - ${localOfficeToAdd.postcode} - ${localOfficeToAdd.county}.`];
        this.ConfirmModalService.pop(msg, title, true, this.i18.organisation.form.okButton, false, "", "info")
        .then(confirmed => {
          if(confirmed){
            return;
          }
        })
      } else {
        this.localOfficeArray.push(localOfficeToAdd);
        this.alertAddedLocalOffice = true;
        this.lastLocalOfficeDeleted = false;
        this.clearLocalOfficeFields();
      }
      
    } else {
      let title = this.i18.organisation.form.addLocalOfficeTitle;
      let msg = [`${this.i18.organisation.form.addLocalOfficeMsg2} "${this.i18.organisation.form.organisationLocalOfficeAddressLabel}"`];
      this.ConfirmModalService.pop(msg, title, true, this.i18.organisation.form.okButton, false, "", "info")
      .then(confirmed => {
        if(confirmed){
          return;
        }
      })
    }
  }

  /**
   * clear local office form fiels after add
   */
  clearLocalOfficeFields(){
    this.localOfficeForm.patchValue({
      id: null,
      address: null,
      postcode: null,
      county: null,
    });
  }

  /**
   * check if local office exists before adding
   * @param localOffice localoffice object
   * @returns 
   */
  localOfficeExists(localOffice: any): boolean {
    for (const office of this.localOfficeArray) {
      if (localOffice.address === office.address
        && localOffice.postcode === office.postcode
        && localOffice.county === office.county) {
          return true;
        }
    }
    return false;
  }

  /**
   * Custom validator that disallows null fields.
   */
   fieldsNotNull(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return control.value !== null ? null : { errorMessage: this.i18.organisation.form.undefinedField }
    }
  }

  /**
   * Custom validator that checks if the field has been specified.
   */
  fieldSpecified(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
      control.value !== this.i18.organisation.form.undefined ? null : { errorMessage: `${this.i18.organisation.form.addLocalOfficeMsg2} ${this.i18.organisation.form.organisationLocalOfficeAddressLabel}` }
  }

  /**
   * Anchor
   * @param target id
   */
  public anchor(target): void {
    this.appService.scrollToTarget(target);
  }

  /**
     * Helper to update the number of notes displayed on top of the page.
     * Checks if the value from the notes component is a number and updates it.
     * If the value is not a number the amount of notes is taken from the notes array received in the initial request.
     * @param numOfNotes 
     */
   setNumOfNotes(numOfNotes: number){
    if(numOfNotes != null && !Number.isNaN(numOfNotes)){
        this.numOfNotes = numOfNotes;
    } else {
        this.numOfNotes = this.employer.notes.length;
    }
  }

    /**
     * Fetches all employers from the backend
     */
    getParentEmployers() {
      this.setDefault();
      this.service.getParentEmployers()
        .subscribe(
          data => this.setParentEmployerList(data),
          error => this.showError(error.error)       
      )
    }

    /**
     * Set the list of all available parent employers (used to choose a subemployers parent on creation)
     * @param data paren employer object
     */
    setParentEmployerList(data){
      this.parentEmployersList = data;
      this.ready = true;
    }

    /**
     * Set the sub employers parent
     * @param data 
     */
    setParentEmployer(data){
      if(data !== undefined && data !== null && data !== 'null'){
        this.parentEmployer = this.parentEmployersList.find(organisation => organisation.id === data);
        this.patchParentEmployer(this.parentEmployer);
        this.parentEmployerSelected = true;
      }
    }

    /**
     * patch the form with parent data when creating/editing a sub employer
     * @param employer 
     */
    patchParentEmployer(employer){
      this.setInputWindow('ADDRESS');
      this.employerForm.patchValue({
        id: null,
        organisationId: employer.organisationId,
        suaStatus: employer.suaStatus,
        employerType: employer.employerType,
        countryCode: employer.countryCode,
        parentOrganisationId: employer.id // the uuid of the parent organisatione
      });
      this.disableParentFields();
    }

    /**
     * Set the parent name and disable fields when new/edit sub employer
     * @param data 
     */
    setParentForEdit(data) {
      this.parentEmployer = data;
      this.parentEmployerSelected = true;
      this.disableParentFields();
    }

    /**
     * disable the parent employer fields from edit when creating or editing a sub employer
     */
    disableParentFields(){
      this.employerForm.get('organisationId').disable();
      //this.employerForm.get('suaStatus').disable();
      this.employerForm.get('employerType').disable();
      //this.employerForm.get('countryCode').disable();
    }
}
